"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @module MessagingModule
 */
var ApiModule_1 = require("./ApiModule");
var transaction_1 = require("../model/transaction");
var transactionBuilder_1 = require("../transactionBuilder");
var utils_1 = require("../utils");
var database_1 = require("../api/model/database");
var crypt_1 = require("../crypt");
var messaging_1 = require("../model/messaging");
var messaging_2 = require("../api/model/messaging");
var types_1 = require("../model/types");
var validator_1 = require("./validator");
var utils_2 = require("../model/utils");
var MessagingModule = /** @class */ (function (_super) {
    __extends(MessagingModule, _super);
    function MessagingModule(dbApi, messageApi) {
        return _super.call(this, {
            dbApi: dbApi,
            messagingApi: messageApi
        }) || this;
    }
    /**
     * List sent messages.
     * https://docs.decent.ch/developer/classgraphene_1_1wallet_1_1detail_1_1wallet__api__impl.html#a2e9a6ada3838f085342b101dd2011b03
     *
     * @param {string} sender                       Account id of sender, in format '1.2.X'. Example '1.2.345'.
     * @param {string} decryptPrivateKey            Private key for memo decryption. Default is ''. Therefore none of messages is decrypted.
     * @param {number} count                        Limit result size. Default 100(Max).
     * @returns {Promise<IDCoreMessagePayload[]>}    List of DCoreMessagePayload objects.
     */
    MessagingModule.prototype.getSentMessages = function (sender, decryptPrivateKey, count) {
        var _this = this;
        if (decryptPrivateKey === void 0) { decryptPrivateKey = ''; }
        if (count === void 0) { count = 100; }
        if (!validator_1.Validator.validateArguments([sender, decryptPrivateKey, count], [types_1.Type.string, types_1.Type.string, types_1.Type.number])) {
            throw new TypeError(messaging_1.MessagingError.invalid_parameters);
        }
        return new Promise((function (resolve, reject) {
            _this.getMessageObjects(sender, '', decryptPrivateKey, count)
                .then(function (messages) {
                resolve(messages);
            })
                .catch(function (err) { return reject(_this.handleError(messaging_1.MessagingError.query_execution_failed, err)); });
        }));
    };
    /**
     * List messages.
     * https://docs.decent.ch/developer/classgraphene_1_1wallet_1_1detail_1_1wallet__api__impl.html#a810a737e6edae4bfb28e89f47833a54b
     *
     * @param {string} receiver                     Account id of receiver, in format '1.2.X'. Example '1.2.345'.
     * @param {string} decryptPrivateKey            Private key to sign transaction.
     * @param {number} count                        Limit result size. Default 100(Max).
     * @returns {Promise<IDCoreMessagePayload[]>}    List of DCoreMessagePayload objects.
     */
    MessagingModule.prototype.getMessages = function (receiver, decryptPrivateKey, count) {
        var _this = this;
        if (decryptPrivateKey === void 0) { decryptPrivateKey = ''; }
        if (count === void 0) { count = 100; }
        if (!validator_1.Validator.validateArguments([receiver, decryptPrivateKey, count], [types_1.Type.string, types_1.Type.string, types_1.Type.number])) {
            throw new TypeError(messaging_1.MessagingError.invalid_parameters);
        }
        return new Promise((function (resolve, reject) {
            _this.getMessageObjects(null, receiver, decryptPrivateKey, count)
                .then(function (messages) {
                resolve(messages);
            })
                .catch(function (err) { return reject(_this.handleError(messaging_1.MessagingError.query_execution_failed, err)); });
        }));
    };
    /**
     * List message objects.
     * https://docs.decent.ch/developer/classgraphene_1_1wallet_1_1detail_1_1wallet__api__impl.html#a7cb689db3eeba6eb74ea2920d5c96236
     *
     * @param {string} sender                       Account id of sender, in format '1.2.X'. Example '1.2.345'.
     * @param {string} receiver                     Account id of receiver, in format '1.2.X'. Example '1.2.345'.
     * @param {string} decryptPrivateKey            Private key to decrypt messages content.
     * @param {number} count                        Limit result count. Default 100(Max)
     * @returns {Promise<IDCoreMessagePayload[]>}    List of DCoreMessagePayload message objects.
     */
    MessagingModule.prototype.getMessageObjects = function (sender, receiver, decryptPrivateKey, count) {
        var _this = this;
        if (sender === void 0) { sender = ''; }
        if (receiver === void 0) { receiver = ''; }
        if (decryptPrivateKey === void 0) { decryptPrivateKey = ''; }
        if (count === void 0) { count = 100; }
        if (!validator_1.Validator.validateArguments([sender, receiver, decryptPrivateKey, count], [types_1.Type.string, types_1.Type.string, types_1.Type.string, types_1.Type.number])) {
            throw new TypeError(messaging_1.MessagingError.invalid_parameters);
        }
        return new Promise((function (resolve, reject) {
            var op = new messaging_2.MessagingOperations.GetMessageObjects(sender || null, receiver || null, count);
            _this.messagingApi.execute(op)
                .then(function (messages) {
                resolve(_this.decryptMessages(messages, decryptPrivateKey));
            })
                .catch(function (err) { return reject(_this.handleError(messaging_1.MessagingError.query_execution_failed, err)); });
        }));
    };
    MessagingModule.prototype.decryptMessages = function (messages, decryptPrivateKey) {
        if (!validator_1.Validator.validateArray(messages, messaging_1.DCoreMessagePayload)
            || !validator_1.Validator.validateArguments([decryptPrivateKey], [types_1.Type.string])) {
            throw new TypeError(messaging_1.MessagingError.invalid_parameters);
        }
        var result = [].concat(messages);
        result.map(function (msg) {
            if (msg.receivers_data.length !== 0) {
                if (msg.receivers_data[0].receiver_pubkey === utils_2.KeyPublic.empty) {
                    msg.text = Buffer.from(msg.receivers_data[0].data, 'hex').toString();
                }
                else {
                    try {
                        msg.text = crypt_1.CryptoUtils.decryptWithChecksum(msg.receivers_data[0].data, decryptPrivateKey, msg.receivers_data[0].receiver_pubkey, msg.receivers_data[0].nonce);
                    }
                    catch (e) {
                        msg.text = '';
                    }
                }
            }
            else {
                msg.text = '';
            }
        });
        return result;
    };
    /**
     * Send encrypted message
     * https://docs.decent.ch/developer/classgraphene_1_1wallet_1_1detail_1_1wallet__api__impl.html#ab7e7eed9c157ff1c352c2179501b36c6
     *
     * @param {string} sender           Account id of sender, in format '1.2.X'. Example '1.2.345'.
     * @param {string} receiverId       Account id of receiver, in format '1.2.X'. Example '1.2.345'.
     * @param {string} message          Content of message.
     * @param {string} privateKey       Private key to encrypt message and sign transaction.
     * @param {boolean} broadcast       Transaction is broadcasted if set to 'true'. Default value is 'true'.
     * @returns {Promise<Operation>}      Value confirming successful transaction broadcasting.
     */
    MessagingModule.prototype.sendMessage = function (sender, receiverId, message, privateKey, broadcast) {
        var _this = this;
        if (broadcast === void 0) { broadcast = true; }
        if (!validator_1.Validator.validateArguments([sender, receiverId, message, privateKey, broadcast], [types_1.Type.string, types_1.Type.string, types_1.Type.string, types_1.Type.string, types_1.Type.boolean])) {
            throw new TypeError(messaging_1.MessagingError.invalid_parameters);
        }
        return new Promise(function (resolve, reject) {
            var getAccOp = new database_1.DatabaseOperations.GetAccounts([receiverId]);
            _this.dbApi.execute(getAccOp)
                .then(function (accounts) {
                if (!accounts || !accounts[0]) {
                    reject(_this.handleError(messaging_1.MessagingError.account_does_not_exist));
                    return;
                }
                var toAccount = accounts[0];
                var messagePayload = {
                    from: sender,
                    pub_from: utils_2.KeyPrivate.fromWif(privateKey).getPublicKey().stringKey,
                    receivers_data: [
                        {
                            to: receiverId,
                            pub_to: toAccount.options.memo_key,
                            nonce: Number(utils_1.Utils.generateNonce()),
                            data: ''
                        }
                    ]
                };
                var encryptedMsg = crypt_1.CryptoUtils.encryptWithChecksum(message, privateKey, toAccount.options.memo_key, messagePayload.receivers_data[0].nonce.toString());
                messagePayload.receivers_data[0].data = encryptedMsg;
                var buffer = Buffer.from(JSON.stringify(messagePayload)).toString('hex');
                var customOp = new transaction_1.Operations.CustomOperation(sender, [sender], messaging_1.CustomOperationSubtype.messaging, buffer);
                var transaction = new transactionBuilder_1.TransactionBuilder();
                transaction.addOperation(customOp);
                _this.finalizeAndBroadcast(transaction, privateKey, broadcast)
                    .then(function (res) { return resolve(res); })
                    .catch(function (err) { return reject(err); });
            })
                .catch(function (err) {
                reject(_this.handleError(messaging_1.MessagingError.api_connection_failed, err));
            });
        });
    };
    /**
     * Send unencrypted message
     * https://docs.decent.ch/developer/classgraphene_1_1wallet_1_1detail_1_1wallet__api__impl.html#ab7e7eed9c157ff1c352c2179501b36c6
     *
     * @param {string} sender           Account id of sender, in format '1.2.X'. Example '1.2.345'.
     * @param {string} receiverId       Account id of receiver, in format '1.2.X'. Example '1.2.345'.
     * @param {string} message          Content of message.
     * @param {string} privateKey       Private key to encrypt message and sign transaction.
     * @param {boolean} broadcast       Transaction is broadcasted if set to 'true'. Default value is 'true'.
     * @returns {Promise<Operation>}      Value confirming successful transaction broadcasting.
     */
    MessagingModule.prototype.sendUnencryptedMessage = function (sender, receiverId, message, privateKey, broadcast) {
        var _this = this;
        if (broadcast === void 0) { broadcast = true; }
        if (!validator_1.Validator.validateArguments([sender, receiverId, message, privateKey, broadcast], [types_1.Type.string, types_1.Type.string, types_1.Type.string, types_1.Type.string, types_1.Type.boolean])) {
            throw new TypeError(messaging_1.MessagingError.invalid_parameters);
        }
        return new Promise(function (resolve, reject) {
            var getAccOp = new database_1.DatabaseOperations.GetAccounts([receiverId]);
            _this.dbApi.execute(getAccOp)
                .then(function (accounts) {
                if (!accounts || !accounts[0]) {
                    reject(_this.handleError(messaging_1.MessagingError.account_does_not_exist));
                    return;
                }
                var messagePayload = {
                    from: sender,
                    pub_from: utils_2.KeyPrivate.fromWif(privateKey).getPublicKey().stringKey,
                    receivers_data: [
                        {
                            to: receiverId,
                            pub_to: utils_2.KeyPublic.empty,
                            nonce: 0,
                            data: Buffer.from(message).toString('hex')
                        }
                    ]
                };
                var buffer = Buffer.from(JSON.stringify(messagePayload)).toString('hex');
                var customOp = new transaction_1.Operations.CustomOperation(sender, [sender], messaging_1.CustomOperationSubtype.messaging, buffer);
                var transaction = new transactionBuilder_1.TransactionBuilder();
                transaction.addOperation(customOp);
                _this.finalizeAndBroadcast(transaction, privateKey, broadcast)
                    .then(function (res) { return resolve(res); })
                    .catch(function (err) { return reject(err); });
            })
                .catch(function (err) {
                reject(_this.handleError(messaging_1.MessagingError.api_connection_failed, err));
            });
        });
    };
    return MessagingModule;
}(ApiModule_1.ApiModule));
exports.MessagingModule = MessagingModule;
//# sourceMappingURL=messaging.js.map


//////////////////
// WEBPACK FOOTER
// ./lib/modules/messaging.js
// module id = 352
// module chunks = 0